import { LandingNews } from '@/shared/model/landing-news.model';
import DataService from '@/core/base/service/data.service';

export default class LandingNewsService extends DataService<LandingNews> {
    protected baseApiUrl: string = 'api/landing-news';
}
